import {
  InwardModel,
  ItemMovementModel,
  ItemMovementModelV2,
} from "../../inventory/models/inventory_voucher";
import { ItemModel, ItemModelV2 } from "../../inventory/models/item_model";
import { UniqueProductModel } from "../../inventory/models/stock_transfer_model";
import { WarehouseModel } from "../../inventory/models/warehouse_model";
import {
  AttachmentModel,
  PurchaseOrderModelV2,
} from "../../purchase_order/model/purchase_order_model";
import {
  LedgerEntryModel,
  OrderDetail,
  orderDetailDefailtValue,
  VoucherModel,
} from "./common_model";
import { PartyModel } from "./party_model";

export interface PurchaseVoucherItemV2 {
  id: string;
  item_id: string;
  item?: ItemModelV2;
  bill_unit_no: number;
  unit_no: number;
  price: number;
  inwards: ItemMovementModelV2[];
}

export interface PurchaseVoucherItem {
  id: string;
  item_id: string;
  item?: ItemModel;
  bill_unit_no: number;
  unit_no: number;
  price: number;
  item_split?: ItemMovementModel[];
}

export const purchaseItemDefaultValueV2: PurchaseVoucherItemV2 = {
  id: "",
  item_id: "",
  bill_unit_no: 0,
  unit_no: 0,
  price: 0,
  inwards: [],
};

export const purchaseItemDefaultValue: PurchaseVoucherItem = {
  id: "",
  item_id: "",
  bill_unit_no: 0,
  unit_no: 0,
  price: 0,
};

export interface PurchaseVoucherFilter {
  all: boolean;
  count: number;
  total?: number;
  page: number;
  toDate?: Date;
  fromDate?: Date;
  delivery_from?: Date;
  delivery_to?: Date;
  gr_number?: string;
  srn_number?: string;
  po_number?: string;
  selectedVendors?: string[];
  selectedWarehouses?: string[];
}

// Whole Inward Model
export interface PurchaseVoucherModelV2 extends VoucherModel {
  date: Date;
  order_detail?: OrderDetail;
  due_date: Date;
  warehouse_id?: string;
  warehouse?: WarehouseModel;
  comment?: string;
  party_id?: string;
  party_detail?: PartyModel;
  item_movements: InwardModel[];
  total_po_qty: number;
  total_received_qty: number;
  uniqueIds?: UniqueProductModel[];
  uniqueIdsCount?: number;
  po_fulfillment_status?: string;
}

export interface PurchaseVoucherDetailedModelV2 extends VoucherModel {
  po: PurchaseOrderModelV2;
  party: PartyModel;
  party_id: string;
  status?: string;
  attachments: AttachmentModel[];
  warehouse_id: string;
  warehouse: WarehouseModel;
  item_movements: ItemMovementModelV2[];
  unique_id?: string;
  project_id: string;
  total_po_qty?: Number;
  total_received_qty: Number;
}

export interface PurchaseVoucherModel extends VoucherModel {
  voucher_type: "Purchase";
  entry_type?: "General" | "Invoice";
  date: Date;

  purchase_ledger_entry: LedgerEntryModel;
  purchase_ledger_entry_id?: string;
  party_ledger_entry: LedgerEntryModel;
  party_ledger_entry_id?: string;

  invoice_date?: Date;
  invoice_no?: string;
  items?: PurchaseVoucherItem[];
  taxes: LedgerEntryModel[];
  tax_ids?: string[];
  tax?: number;
  extras: LedgerEntryModel[];
  extra_ids?: string[];
  extra?: number;
  discounts: LedgerEntryModel[];
  discount_ids?: string[];
  sub_total: number;
  discount?: number;
  total: number;
  paid: number;
  due_date: Date;
  credit_period_day?: number;
  party_detail?: PartyModel;
  party_id?: string;
  order_detail?: OrderDetail;
  remark?: string;
  project_id?: string;
  project?: string;
}

export const ledgerEntryDefaultValue: LedgerEntryModel = {
  ledger_id: "",
  voucher_id: "",
  voucher_type: "",
  date: new Date(),
  type: "",
  amount: 0,
};
export const defaultPurchaseValueV2: PurchaseVoucherModelV2 = {
  date: new Date(),
  due_date: new Date(),
  attachments: [],
  voucher_type: "",
  warehouse_id: "",
  warehouse: undefined,
  item_movements: [],
  total_po_qty: 0,
  total_received_qty: 0,
};
export const defaultPurchaseValue: PurchaseVoucherModel = {
  voucher_type: "Purchase",
  entry_type: "Invoice",
  date: new Date(),
  due_date: new Date(),
  taxes: [],
  discounts: [],
  sub_total: 0,
  total: 0,
  paid: 0,
  purchase_ledger_entry: ledgerEntryDefaultValue,
  party_ledger_entry: ledgerEntryDefaultValue,
  purchase_ledger_entry_id: "",
  party_ledger_entry_id: "",
  tax_ids: [],
  discount_ids: [],
  order_detail: orderDetailDefailtValue,
  attachments: [],
  extras: [],
};
